<form class="customForm" [formGroup]="postPropertyForm">
  <div class="popupTitle">Post Inventory</div>
  <div class="row">
    <div class="col-md-12">
      <div class="form-filed ng-selectBox">
        <span class="label">City <span class="strick">*</span></span>
        <ng-select
          [items]="cityListArr"
          bindLabel="city"
          bindValue="id"
          formControlName="city"
          placeholder="City"
          [clearable]="false"
        ></ng-select>
      </div>
    </div>

    <div class="col-md-12">
      <div class="form-filed ng-selectBox">
        <span class="label">Inventory Type <span class="strick">*</span></span>
        <div class="chipMainBox">
          <div
            class="chip-item"
            *ngFor="let data of propertyType"
            (click)="onChangePropertyType(data)"
            [class.active]="data.isSelected === true"
          >
            {{ data.name }}
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12" *ngIf="selectedPropertyTypeObj">
      <div class="form-filed ng-selectBox">
        <span class="label">Service Type <span class="strick">*</span></span>
        <div class="chipMainBox">
          <div
            class="chip-item"
            *ngFor="let data of selectedPropertyTypeObj"
            [class.active]="data.isSelected === true"
            (click)="onChangeServiceType(data)"
          >
            {{ data.name }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popBtm">
    <button type="button" class="cancel-btn" (click)="closeModal()">
      Cancel
    </button>
    <button
      type="submit"
      class="submit-btn"
      (click)="onSave()"
      [disabled]="postPropertyForm.invalid"
    >
      Save
    </button>
  </div>
</form>
